import * as React from 'react';

import { ArrowRight } from '@/components/icons';

import styles from './SectionHeader.module.scss';

interface SectionHeaderProps {
  headingElement?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'span';
  heading?: string;
  button?: {
    text: string;
    path?: string;
    notIndexed?: boolean;
    onClick: (event: React.MouseEvent<HTMLAnchorElement>) => void;
  };
}

export const SectionHeader: React.FC<SectionHeaderProps> = ({
  heading,
  headingElement = 'h2',
  button,
}) => {
  return (
    <header className={styles.header}>
      <div className={styles.mainInfoArea}>
        {heading &&
          React.createElement(
            headingElement,
            {
              'data-testid': 'section-header-heading',
              className: styles.heading,
            },
            heading
          )}
      </div>
      <div className={styles.buttonContainer}>
        {button && (
          <a
            className={styles.button}
            data-testid="section-header-button"
            onClick={e => {
              e.preventDefault();
              button.onClick(e);
            }}
            href={button.path}
            rel={button.notIndexed ? 'nofollow' : ''}
          >
            <>
              <span>{button.text}</span>
              <ArrowRight className={styles.icon} />
            </>
          </a>
        )}
      </div>
    </header>
  );
};

export default SectionHeader;
